<template>
  <main class="login-page">
    <section class="login-panel">
      <router-link to="/" class="site-brand">
        <BrandLogo />
      </router-link>
      <h1>Recuperar senha</h1>
      <p>Informe seu e-mail para receber um código de 6 dígitos e validar a redefinição.</p>

      <v-form @submit.prevent="submit">
        <v-text-field v-model="email" label="Email corporativo" outlined dense />
        <v-alert v-if="message" type="success" dense text>
          {{ message }}
          <span v-if="devCode"> Código: {{ devCode }}</span>
        </v-alert>
        <v-alert v-if="error" type="error" dense text>{{ error }}</v-alert>
        <v-btn block color="primary" height="44" type="submit" :loading="loading">Enviar código</v-btn>
      </v-form>

      <div class="auth-links">
        <router-link :to="{ name: 'reset-password', query: { email } }">Já tenho código</router-link>
        <router-link to="/login">Voltar ao login</router-link>
      </div>
    </section>
  </main>
</template>

<script>
import api from '../../plugins/axios'
import BrandLogo from '../../components/BrandLogo.vue'

export default {
  name: 'ForgotPasswordPage',
  components: {
    BrandLogo
  },
  data () {
    return {
      email: '',
      loading: false,
      message: '',
      devCode: '',
      error: ''
    }
  },
  methods: {
    async submit () {
      this.loading = true
      this.message = ''
      this.devCode = ''
      this.error = ''

      try {
        const { data } = await api.post('/auth/password/forgot', { email: this.email })
        this.message = data.message
        this.devCode = data.code || ''
      } catch (error) {
        this.error = 'Não foi possível gerar o código.'
      } finally {
        this.loading = false
      }
    }
  }
}
</script>
